<template>
  <div class="container">
    <caregiver-form
        @submit="createCaregiver"
        @cancel="cancelCreateCaregiver"
        v-loading.fullscreen.lock="fullscreenLoading"
        :caregiver="caregiver"
    />
  </div>
</template>

<style lang="scss" scoped>
  .container {
    padding-left: 200px;
    padding-right: 200px;
  }
</style>

<script>
import CaregiverForm from './CaregiverForm'
import CaregiverModel from '../../model/CaregiverModel'
import { GenericAPIHandler } from '../shared/GenericAPIHandler'

export default {
  name: 'CaregiverCreate',
  mixins: [GenericAPIHandler],
  data () {
    return {
      fullscreenLoading: false,
      caregiver: new CaregiverModel(),
    }
  },
  components: {
    CaregiverForm,
  },
  methods: {
    cancelCreateCaregiver () {
      this.showCancelDialog({ name: 'CaregiverBoard' })
    },
    async createCaregiver (caregiver) {
      try {
        this.fullscreenLoading = true
        await this.$api.Caregiver.create(this.clearWoundCareData(caregiver))
        this.showSuccessDialog({ name: 'CaregiverBoard' })
      } catch (error) {
        this.showErrorDialog(error)
      } finally {
        this.fullscreenLoading = false
      }
    },
    clearWoundCareData (caregiver) {
      if (caregiver.skills.includes('woundCare')) {
        caregiver.skillScores = caregiver.skillScores.filter((item) => {
          return item.name !== 'woundCare'
        })
        caregiver.skills = caregiver.skills.filter((item) => {
          return item !== 'woundCare'
        })
      }
      return caregiver
    },
  },
}
</script>
